export function WindowPopup(url, title, w, h) {
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  return window.open(
    url,
    title,
    'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
      w +
      ', height=' +
      h +
      ', top=' +
      top +
      ', left=' +
      left
  );
}

export function orderBy(data, value) {
  return data.sort((a, b) => {
    if (a[value] > b[value]) {
      return -1;
    }
    if (a[value] < b[value]) {
      return 1;
    }
    return 0;
  });
}

export function filterByValue(array, string) {
  return array.filter(o => {
    return Object.keys(o).some(k => {
      return (o[k] + '').toLowerCase().includes(string.toLowerCase());
    });
  });
}
